
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TourRegisterProperties } from "./Poker2TourRegisterProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TourRegisterDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TourRegisterDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }
    protected applyProperties(): void {
        this.registerDialog.txt_title.text = (this.registerDialogProperties.tournamentName) ? this.registerDialogProperties.tournamentName : Poker2Model.languageData.getTextById("dialog_tour_register_title");
        this.registerDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_tour_register_copy");
        this.registerDialog.txt_copy2.text = Poker2Model.languageData.getTextById("dialog_tour_register_copy_2");
        this.registerDialog.txt_chips_value.text = NumberStringHelper.groupString(this.registerDialogProperties.chipsFee, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.registerDialog.txt_gold_value.text = NumberStringHelper.groupString(this.registerDialogProperties.goldFee, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        this.registerDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_yes");
        this.registerDialog.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_no");
    }
    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.registerDialog.btn_cancle:
                this.hide();
                break;
            case this.registerDialog.btn_ok:
                this.hide();
                if (this.registerDialogProperties.functionOk != null)
                    this.registerDialogProperties.functionOk(this.registerDialogProperties.tournamentId);
                break;
        }
    }
    protected get registerDialogProperties(): Poker2TourRegisterProperties {
        return this.properties as Poker2TourRegisterProperties;
    }
    protected get registerDialog(): Library.PokerInterface.PokerTournamentRegister {
        return this.disp as Library.PokerInterface.PokerTournamentRegister;
    }
}
